<template>
  <div class="content__column content__column--small" v-if="gallery">
    <h1 class="content__title">Editar Galería</h1>
    <form class="form" @submit.prevent="saveGallery">
      <div class="fom__fieldset">
        <div class="form__container">
          <label for="name" class="form__label form__label--required">Nombre de la Galería</label>
          <input type="text" class="form__input" name="name" id="name" v-model="gallery.name" v-validate="validation.name">
          <span v-show="errors.has('name')" class="form__alert" v-text="errors.first('name')"></span>
        </div>
        <div class="form__container">
          <label for="title" class="form__label">Título de la Galería</label>
          <input type="text" class="form__input" name="title" id="title" v-model="gallery.title" v-validate="validation.title">
          <span v-show="errors.has('title')" class="form__alert" v-text="errors.first('title')"></span>
        </div>
        <div class="form__container">
          <label for="description" class="form__label">Descripción de la Galería</label>
          <textarea type="text" class="form__input form__input--textarea" name="description" id="description" v-model="gallery.description" v-validate="validation.description"></textarea>
          <span v-show="errors.has('description')" class="form__alert" v-text="errors.first('description')"></span>
        </div>
        <div class="form__container">
          <label class="form__label form__label--required" for="status_id"> Estatus de la galería</label>
          <div class="form__select-container">
            <select name="status_id" id="status_id" class="form__select" v-validate="validation.status_id" v-model="gallery.status_id">
              <option hidden :value="null">Elija un estatus</option>
              <option v-for="(status, index) in gallery_status" :key="index" :value="status.id" v-text="status.name"></option>
            </select>
          </div>
          <span v-show="errors.has('status_id')" class="form__alert" v-text="errors.first('status_id')"></span>
        </div>
        <div class="form__container">
          <label class="form__label" for="group_id"> Grupos Galerías</label>
          <div class="form__select-container">
            <select name="group_id" id="group_id" class="form__select" v-validate="validation.group_id" v-model="gallery.group_id">
              <option :value="null">Elija un grupo</option>
              <option v-for="(group, index) in groups" :key="index" :value="group.id" v-text="group.name"></option>
            </select>
          </div>
          <span v-show="errors.has('group_id')" class="form__alert" v-text="errors.first('group_id')"></span>
        </div>
        <div class="form__container">
          <div class="form__image">
            <label class="form__label" for="cover">Cover de la galería</label>
            <img :src="cover" alt="Gallery Cover" class="form__thumb">
            <button class="btn btn__action btn--small" @click.prevent="showMedia = true">Cargar Imagen</button>
            <button v-if="gallery.cover" class="btn btn__transparent btn--small" @click.prevent="cover = null">Quitar Imagen</button>
          </div>
        </div>
      </div>
      <input type="submit" class="btn btn__action btn--regular" value="Guardar">
      <button @click.prevent="$emit('new')" class="btn btn__transparent btn--regular">Agregar Nueva Galería</button>
    </form>
    <media-popup @close="showMedia = false" v-if="showMedia" field="cover"></media-popup>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import {gallery_status} from './mocks'
import mediaPopup from '@/components/media/popup'
import {config} from '@/core/config/base'
import Mixins from './mixins'
export default {
  props: {
    gallery: {
      type: Object,
      required: false,
      default: function () {
        return {
          id: null,
          name: null,
          title: null,
          description: null,
          status_id: null,
          group_id: null,
          cover: null
        }
      }
    }
  },
  mixins: [
    httpService,
    Mixins
  ],
  components: {
    mediaPopup
  },
  data: function () {
    return {
      newImage: false,
      showMedia: false,
      gallery_status: gallery_status,
      validation: {
        name: 'required|max:50',
        title: 'max:255',
        status_id: 'required|min_value:1|max:4',
        group_id: 'min_value:1|max:11'
      }
    }
  },
  created: function () {
    this.getGroups()
  },
  mounted: function () {
    this.$on('cover', media => {
      this.cover = media.image
    })
  },
  methods: {
    saveGallery: function () {
      this.$validator.validateAll()
        .then(
          result => {
            if (result) {
              let httpRequest = {
                params: '',
                module: 'galleries',
                element: this.gallery
              }
              let action
              if (this.gallery.id) {
                action = this.put(this.gallery.id, httpRequest)
              } else {
                action = this.post(httpRequest)
              }
              action.then(
                response => {
                  if (!this.gallery.id) {
                    this.gallery.id = response.data.current_id
                  }
                  this.$store.commit('elementChanged', {
                    module: 'galleryEdit',
                    time: Math.round((new Date()).getTime() / 1000)
                  })
                  this.$store.commit('notificate', {
                    title: 'GALERÍA GUARDADA',
                    text: 'La galería ha sido guardada correctamente',
                    type: 'success'
                  })
                }
              ).catch(
                () => {
                  this.$store.commit('notificate', {
                    title: 'GALERÍA NO GUARDADA',
                    text: 'La galería no ha sido guardada, por favor, intente más tarde',
                    type: 'error'
                  })
                }
              )
            }
          }
        )
    }
  },
  computed: {
    cover: {
      get: function () {
        if (this.gallery.cover) {
          let image = undefined
          if (this.newImage) {
            image = this.gallery.cover
          } else {
            image = JSON.parse(this.gallery.cover)
          }
          return config.statics.url + image.sizes.small
        } else {
         return config.statics.dummy
        }
      }, set: function (value) {
        this.newImage = true
        this.gallery.cover = value
      }
    }
  }
}
</script>

<style lang="sass">
  @import "../../assets/sass/components/_forms"
</style>


// WEBPACK FOOTER //
// src/components/galleries/edit.vue